import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { LESSON_CARD_DESCRIPTION_READ_MORE_THRESHOLD } from '@/utils/lessonDisplay';

type LessonCardDescriptionBlurbProps = {
  description: string | null | undefined;
  /** e.g. `/academy/:slug/lessons#lesson-uuid` */
  readMoreTo: string;
  className?: string;
  /** Override default muted text (e.g. `text-gray-600 dark:text-gray-400` on PublicLessonsPage). */
  textClassName?: string;
};

/** Truncated lesson blurb for cards; full description on the lessons page (see hash scroll). */
export function LessonCardDescriptionBlurb({
  description,
  readMoreTo,
  className,
  textClassName,
}: LessonCardDescriptionBlurbProps) {
  const trimmed = description?.trim();
  if (!trimmed) return null;
  const showReadMore = trimmed.length > LESSON_CARD_DESCRIPTION_READ_MORE_THRESHOLD;

  return (
    <div className={cn('mt-2', className)}>
      <p className={cn('text-sm line-clamp-4 break-words', textClassName ?? 'text-muted-foreground')}>
        {trimmed}
      </p>
      {showReadMore ? (
        <Link
          to={readMoreTo}
          className="mt-1.5 inline-flex text-sm font-medium text-primary hover:underline"
        >
          Read more
        </Link>
      ) : null}
    </div>
  );
}
